import { render, staticRenderFns } from "./PageOrders.vue?vue&type=template&id=80e8c870&"
import script from "./PageOrders.vue?vue&type=script&lang=js&"
export * from "./PageOrders.vue?vue&type=script&lang=js&"
import style0 from "./PageOrders.vue?vue&type=style&index=0&id=80e8c870&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports